module.exports = __webpack_public_path__ + "static/media/billboard.630c8089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/billboard.png
// module id = 514
// module chunks = 0